module.exports = __webpack_public_path__ + "img/portugal-cardiovascular-diseases-male.09f6a7e6.png";